export const Footer = {
  FOOTER_TERMS: ['개인정보 처리방침', '서비스 이용약관', '서비스 문의'],
  FOOTER_ADDRESS: '서울 중구 명동길 73 5층 (주) 제네시스랩',
  FOOTER_BUSINESS_REGISTRATION_NUMBER: '사업자등록번호 421-88-00471',
  FOOTER_COPYRIGHT: '© Genesis Lab, Inc.  All rights reserved.',
};
